'use client';

import { useEffect } from 'react';
import Link from 'next/link';

/** Keep the next purchase step reachable without covering chat or phone safe areas. */
export default function MobilePurchaseBar({ label, amount, href, action, disabled = false }: {
  label: string;
  amount: string;
  href: string;
  action: string;
  disabled?: boolean;
}) {
  useEffect(() => {
    const media = window.matchMedia('(max-width: 1023px)');
    const apply = () => document.documentElement.style.setProperty('--config-bar-h', media.matches ? 'calc(80px + env(safe-area-inset-bottom, 0px))' : '0px');
    apply();
    media.addEventListener('change', apply);
    return () => {
      media.removeEventListener('change', apply);
      document.documentElement.style.removeProperty('--config-bar-h');
    };
  }, []);

  return <>
    <div className="lg:hidden h-[calc(80px+env(safe-area-inset-bottom,0px))]" aria-hidden="true" />
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 border-t border-gray-200 bg-white px-4 pt-3 pb-[calc(12px+env(safe-area-inset-bottom,0px))] shadow-[0_-4px_16px_rgba(0,0,0,0.08)]" aria-label="Purchase actions">
      <div className="mx-auto flex max-w-xl items-center gap-3">
        <div className="min-w-0 flex-1">
          <p className="text-sm text-gray-600">{label}</p>
          <p className="text-lg font-bold tabular-nums text-gray-900">{amount}</p>
        </div>
        {disabled ? <span className="inline-flex min-h-12 items-center justify-center rounded-lg bg-gray-200 px-5 font-semibold text-gray-600" role="status">Updating…</span> :
          <Link href={href} className="inline-flex min-h-12 items-center justify-center rounded-lg bg-primary-red px-5 text-base font-bold text-white hover:bg-primary-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-red focus-visible:ring-offset-2">{action}</Link>}
      </div>
    </div>
  </>;
}
